export default {
  DREHubAnalyticsConfigurations: (state) => state.hubAnalyticsConfigurations.DRE,
  RFVHubAnalyticsConfigurations: (state) => state.hubAnalyticsConfigurations.RFV,
  hubAnalyticsLimits: (state) => state.hubAnalyticsLimits,
  loadingReportsList: (state) => state.loadingReportsList,
  entitiesLinkedByHubConfiguration: (state) => state.entitiesLinkedByHubConfiguration,
}
